<template>
    <p-modal
        @ok="exportTextbookListReport"
        size="lg"
        name="exportTextbookListModal"
        :label="exportTextbookListLabel"
        ref="exportTextbookListModal"
        @show="initialize"
    >
        <template v-slot:default>
            <p-form ref="textbookListForm">
                <div class="container-fluid content-wrapper">
                    <b-row cols="1">
                        <b-col>
                            <p-advanced-select
                                v-model="selectedTermId"
                                label="Term"
                                data-type="terms"
                                filter="True"
                                rules="required" />
                            <p-card class="mb-2 ps-2 py-2" no-body>
                                <label class="text-sm" v-if="courseSectionSelectHelpText">{{ courseSectionSelectHelpText }}</label>
                                <course-sections-selector
                                    class="pt-2"
                                    @selection-change="
                                        textbookListParameters.courseSections = $event
                                    "
                                    :course-request="mockCourseRequest"
                                    filter-course-data
                                    :select-filtered-data="false"
                                    :show-closed-term-option="false"
                                    :show-expand-all-option="true" />
                            </p-card>
                        </b-col>
                    </b-row>
                </div>
            </p-form>
        </template>
        <template v-slot:modal-footer="{ ok, cancel }">
            <b-row>
                <b-col>
                    <p-button :is-busy="isBusy" variant="outline-primary" @click="cancel">Cancel</p-button>
                    <p-button :is-busy="isBusy" variant="primary" @click="ok" class="ms-2">OK</p-button>
                </b-col>
            </b-row>
        </template>
    </p-modal>
</template>

<script>

import axios from 'axios';
import { downloadFileToBrowser } from '@/components/Common/BrowserDownload.js';
import { getExportMessage } from '@/components/Common/ExportMessage.js';
import { useSelectListsStore } from '@/stores/selectLists.js';
import CourseSectionsSelector from '@/components/CourseSectionsSelector';

export default {
    props: {
        termId: {
            type: Number,
            required: false
        },
    },
    data() {
        return {
            selectedTermId: null,
            isBusy: false,
            reportType: 'csv',
            textbookListParameters: {
                termId: null,
                courseSections: []
            }
        };
    },
    components: {
        CourseSectionsSelector
    },
    computed: {
        // the format comes from the export dropdown, so the title has to say which one is being exported
        exportTextbookListLabel() {
            return `Export Textbook List (${this.reportType.toUpperCase()})`;
        },
        mockCourseRequest() {
            return { termId: this.selectedTermId };
        },
        courseSectionSelectHelpText() {
            if (!this.selectedTermId) {
                return 'Please select a term to select sections from.';
            }
            return this.textbookListParameters.courseSections.length === 0
                ? 'ALL sections for this term will be included in the textbook list, you may select individual sections below.'
                : '';
        }
    },
    methods: {
        async exportTextbookListReport(bvModalEvt) {
            bvModalEvt.preventDefault();
            if (!(await this.$refs.textbookListForm.validate())) {
                return;
            }

            this.textbookListParameters.termId = this.selectedTermId;
            this.isBusy = true;

            let fileName = `Textbook List-${useSelectListsStore().getTermById(this.selectedTermId)?.text}.csv`;

            axios
                .post('/terms/exportTextbookListCsv', this.textbookListParameters, {
                    responseType: 'blob'
                })
                .then(result => {
                    downloadFileToBrowser(result.data, fileName, 'application/csv');

                    // The interceptor raises the api's own message, so only claim success without one.
                    if (!getExportMessage(result)) {
                        this.$appSuccess(
                            `Textbook list report generated successfully.`
                        )
                    }

                    this.$refs.exportTextbookListModal.hide();
                })
                .finally(() => {
                    this.isBusy = false;
                    this.textbookListParameters.courseSections = [];
                });
        },
        // the term being edited is only a starting point here - unlike the other term reports the
        // selector stays visible so it can be changed without leaving the modal
        initialize() {
            this.selectedTermId = this.termId || null;
            this.textbookListParameters = {
                termId: null,
                courseSections: []
            }
        },
        // reportType is supplied by the caller ('csv' today) so the modal can name the format it will export
        show(reportType = 'csv') {
            this.reportType = reportType;
            this.$refs.exportTextbookListModal.show();
        },
    }
};

</script>
